export const DURATION_SLOW = 400;
export const MOBILE_WIDTH = 768;
export const ACCELERATED_SYNTHETIC_SCROLL_MULTIPLIER = 16;
export var Size;
(function (Size) {
    Size["None"] = "none";
    Size["XXS"] = "xxs";
    Size["XS"] = "xs";
    Size["S"] = "s";
    Size["M"] = "m";
    Size["L"] = "l";
    Size["XL"] = "xl";
    Size["XXL"] = "xxl";
    Size["Auto"] = "auto";
    Size["Min"] = "min";
    Size["Container"] = "container";
})(Size || (Size = {}));
export var ScrollStatus;
(function (ScrollStatus) {
    ScrollStatus["Top"] = "ScrollStatus::Top";
    ScrollStatus["Scrolled"] = "ScrollStatus::Scrolled";
    ScrollStatus["Bottom"] = "ScrollStatus::Bottom";
    ScrollStatus["NoScroll"] = "ScrollStatus::NoScroll";
})(ScrollStatus || (ScrollStatus = {}));
export var Direction;
(function (Direction) {
    Direction["Left"] = "LEFT";
    Direction["Right"] = "RIGHT";
})(Direction || (Direction = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection || (SortDirection = {}));
export var RowBreakpoint;
(function (RowBreakpoint) {
    RowBreakpoint["Xs"] = "xs";
    RowBreakpoint["Sm"] = "sm";
    RowBreakpoint["Md"] = "md";
    RowBreakpoint["Lg"] = "lg";
    RowBreakpoint["Xl"] = "xl";
})(RowBreakpoint || (RowBreakpoint = {}));
export var ListType;
(function (ListType) {
    ListType[ListType["Numbers"] = 0] = "Numbers";
    ListType[ListType["Bullets"] = 1] = "Bullets";
})(ListType || (ListType = {}));
export var TableVariant;
(function (TableVariant) {
    TableVariant["Head"] = "head";
    TableVariant["Body"] = "body";
    TableVariant["Foot"] = "foot";
})(TableVariant || (TableVariant = {}));
export var Key;
(function (Key) {
    Key["Unidentified"] = "Unidentified";
    Key["Alt"] = "Alt";
    Key["AltGraph"] = "AltGraph";
    Key["CapsLock"] = "CapsLock";
    Key["Control"] = "Control";
    Key["Fn"] = "Fn";
    Key["FnLock"] = "FnLock";
    Key["NumLock"] = "NumLock";
    Key["ScrollLock"] = "ScrollLock";
    Key["Shift"] = "Shift";
    Key["Enter"] = "Enter";
    Key["Tab"] = "Tab";
    Key["ArrowDown"] = "ArrowDown";
    Key["ArrowLeft"] = "ArrowLeft";
    Key["ArrowRight"] = "ArrowRight";
    Key["ArrowUp"] = "ArrowUp";
    Key["End"] = "End";
    Key["Home"] = "Home";
    Key["PageDown"] = "PageDown";
    Key["PageUp"] = "PageUp";
    Key["Backspace"] = "Backspace";
    Key["Delete"] = "Delete";
    Key["Insert"] = "Insert";
    Key["ContextMenu"] = "ContextMenu";
    Key["Escape"] = "Escape";
    Key["PrintScreen"] = "PrintScreen";
    Key["Alphanumeric"] = "Alphanumeric";
    Key["Multiply"] = "Multiply";
    Key["Add"] = "Add";
    Key["Divide"] = "Divide";
    Key["Subtract"] = "Subtract";
    Key["Separator"] = "Separator";
    Key["Space"] = " ";
})(Key || (Key = {}));
//# sourceMappingURL=constants.js.map